<template>
  <div class="MyFollow FollowSymbol">
    <div class="PageCommon">
      <div class="bscroll" ref="bscroll">
        <div class="bscroll-container">
          <h3 class="pageTitle" v-if="!mobileFlag">
            {{ $t("Menu_Signal_AllFollowing") }}
            <div class="refreshListBtnDiv">
              <el-button class="confirmDialogBtn" @click="getData(1, pageSize)">
                {{ $t("Common_Operation_Refresh") }}
                <i class="el-icon-refresh-right"></i>
              </el-button>
            </div>
          </h3>
          <div class="mobileFilterDiv" v-if="mobileFlag">
            <el-button
              class="mobileFilterBtn"
              @click="openSearch()"
              type="text"
              size="small"
            >
              {{ $t("Common_Operation_Filter") }}
              <svg-icon
                class="greenIcon"
                icon-class="MobileFilterBtn"
              ></svg-icon>
            </el-button>
          </div>

          <div class="tableSearch" v-if="!mobileFlag">
            <el-form
              label-position="top"
              :model="tableSearchForm"
              ref="tableSearchForm"
            >
              <el-form-item
                :label="$t('Common_TableTitle_SignalSource')"
                prop="PortfolioName"
              >
                <el-input v-model="tableSearchForm.PortfolioName"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('Common_TableTitle_Mt4Account')"
                prop="Account"
              >
                <el-input v-model="tableSearchForm.Account"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('Common_TableTitle_CustomerEmail')"
                prop="LoginName"
              >
                <el-input v-model="tableSearchForm.LoginName"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('Common_TableTitle_AutoMatchOrder')"
                prop="AutoRecon"
              >
                <el-select v-model="tableSearchForm.AutoRecon">
                  <el-option :label="$t('Common_Yes')" value="true"></el-option>
                  <el-option :label="$t('Common_No')" value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('Common_TableTitle_Status')"
                prop="Status"
              >
                <el-select v-model="tableSearchForm.Status">
                  <el-option
                    :label="$t('Common_AllStatus')"
                    value=""
                  ></el-option>
                  <el-option
                    :label="$t('Common_InvitationStatus_Inviting0')"
                    value="0"
                  ></el-option>
                  <el-option
                    :label="$t('Common_InvitationStatus_AgreeWatingActivate4')"
                    value="4"
                  ></el-option>
                  <el-option
                    :label="$t('Common_InvitationStatus_BeRefuse2')"
                    value="2"
                  ></el-option>
                  <el-option
                    :label="$t('Common_InvitationStatus_Agree1')"
                    value="1"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button class="serchFormBtn" @click="getData(1, pageSize)">
              {{ $t("Common_Search") }}
              <svg-icon icon-class="SearchIcon"></svg-icon>
            </el-button>
            <el-button class="resetFormBtn" @click="resetForm()">
              {{ $t("Common_Reset") }}
              <svg-icon icon-class="ResetIcon"></svg-icon>
            </el-button>
          </div>
          <div class="tableDiv" v-if="!mobileFlag">
            <el-table
              :data="tableData"
              style="width: 100%"
              ref="dataTable"
              :summary-method="getSummaries"
              show-summary
            >
              <el-table-column
                width="80"
                v-if="!mobileFlag"
                prop="sortNum"
                :label="$t('Common_TableTitle_Number')"
              >
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_SignalSource'))"
                prop="portfolioName"
                :label="$t('Common_TableTitle_SignalSource')"
              >
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_CustomerEmail'))"
                prop="loginName"
                :label="$t('Common_TableTitle_CustomerEmail')"
              >
              </el-table-column>
              <el-table-column
                prop="account"
                :label="$t('Common_TableTitle_Mt4Account')"
              >
                <template slot-scope="scope">
                       <!-- <div v-if="scope.row.status == 1 || scope.row.status == 4" class="mt4Click"> -->
                  <div v-if="scope.row.status == 1 || scope.row.status == 4">
                    {{ scope.row.mtType }}.{{ scope.row.account }}
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="balance"
                :label="$t('Common_TableTitle_Balance')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.balance
                        ? formatNumberFractionDigits(scope.row.balance)
                        : "0"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="equity"
                :label="$t('Common_TableTitle_Equity')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.equity
                        ? formatNumberFractionDigits(scope.row.equity)
                        : "0"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :width="flexLabelWidth($t('Common_TableTitle_CopyRatio'))"
                :label="$t('Common_TableTitle_CopyRatio')"
              >
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.followPercent + "%" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="maxVolume"
                width="100"
                :label="$t('Common_TableTitle_MaxLot')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.maxVolume == 0
                        ? $t("Common_TR_VolumeNotLimit")
                        : scope.row.maxVolume
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="symbols"
                width="135"
                :label="$t('Common_TableTitle_Instruments')"
              >
                <template slot-scope="scope">
                  <div>
                    <span class="symbolsSpan" v-if="scope.row.forexSelect">
                      {{ $t("Common_Fx") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.metalsSelect">
                      {{ $t("Common_Metal") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.energySelect">
                      {{ $t("Common_Energy") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.indicesSelect">
                      {{ $t("Common_Indices") }}
                    </span>
                    <span class="symbolsSpan" v-if="scope.row.cryptoSelect">
                      {{ $t("Common_Crypto") }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                :label="$t('Common_TableTitle_AutoMatchOrder')"
              >
                <template slot-scope="scope">
                  <div>
                    <el-result
                      v-if="scope.row.autoRecon"
                      icon="success"
                    ></el-result>
                    <el-result
                      v-if="!scope.row.autoRecon"
                      icon="error"
                    ></el-result>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="volume"
                width="120"
                :label="$t('Common_TableTitle_Volumes')"
              >
              </el-table-column>
              <el-table-column
                prop="profit"
                :label="$t('Common_TableTitle_ProfitLoss')"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      scope.row.profit
                        ? formatNumberFractionDigits(scope.row.profit)
                        : "0"
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :width="
                  mobileFlag ? 150 : flexLabelWidth($t('Common_LoginStatus'))
                "
                prop="loginStatus"
                :label="$t('Common_LoginStatus')"
              >
                <template slot-scope="scope">
                  <div>
                    <div class="loginStatus" v-if="scope.row.loginStatus == 0">
                      <el-result icon="success"></el-result>
                      <span>{{ $t("Common_LoginStatusOnline") }}</span>
                    </div>
                    <div class="loginStatus" v-if="scope.row.loginStatus !== 0">
                      <el-result icon="error"></el-result>
                      <span>{{ $t("Common_LoginStatusOutline") }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="140"
                :label="$t('Common_TableTitle_Status')"
                class="statusBr"
              >
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.status == 0" class="statusGreen">{{
                      $t("Common_InvitationStatus_Inviting0")
                    }}</span>
                    <span v-if="scope.row.status == 4" class="statusYellow">{{
                      $t("Common_InvitationStatus_AgreeWatingActivate4")
                    }}</span>
                    <span v-if="scope.row.status == 2" class="statusRed">{{
                      $t("Common_InvitationStatus_BeRefuse2")
                    }}</span>
                    <span v-if="scope.row.status == 1" class="statusYellow">{{
                      $t("Common_InvitationStatus_Agree1")
                    }}</span>
                    <span v-if="scope.row.status == 3" class="statusRed">{{
                      $t("Common_InvitationStatus_Stop3")
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="150"
                prop="followTime"
                :label="$t('Common_StartFollowHistory')"
              >
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.status == 1 ? scope.row.followTime : "" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :fixed="tableData.length !== 0 ? 'right' : false"
                v-if="!mobileFlag"
                width="135"
                :label="$t('Common_TableTitle_Operation')"
              >
                <template slot-scope="scope">
                  <div class="operateBtns">
                    <el-button
                      v-if="scope.row.status == 4"
                      @click="activateFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="ActivateIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_Activation") }}
                    </el-button>
                    <el-button
                      v-if="scope.row.status !== 1 && scope.row.status !== 4"
                      @click="retractFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="RetractIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_DeleteInvite") }}
                    </el-button>
                    <el-button
                      v-if="scope.row.status == 0 || scope.row.status == 2"
                      @click="editFollow(scope.row)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="SettingIcon"
                      ></svg-icon>
                      {{ $t("Common_Setting") }}
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="mobileFlag"
                :fixed="tableData.length !== 0 ? 'right' : false"
                width="80"
                :label="$t('Common_TableTitle_Operation')"
              >
                <template slot-scope="scope">
                  <div class="operateBtns">
                    <el-popover placement="bottom-end" trigger="click">
                      <el-button
                        v-if="scope.row.status == 4"
                        @click="activateFollow(scope.row)"
                        type="text"
                        size="small"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      >
                        <svg-icon
                          class="greenIcon"
                          icon-class="ActivateIcon"
                        ></svg-icon>
                        {{ $t("Common_Operate_Activation") }}
                      </el-button>
                      <el-button
                        v-if="scope.row.status !== 1 && scope.row.status !== 4"
                        @click="retractFollow(scope.row)"
                        type="text"
                        size="small"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      >
                        <svg-icon
                          class="greenIcon"
                          icon-class="RetractIcon"
                        ></svg-icon>
                        {{ $t("Common_Operate_DeleteInvite") }}
                      </el-button>
                      <el-button
                        v-if="scope.row.status == 0 || scope.row.status == 2"
                        @click="editFollow(scope.row)"
                        type="text"
                        size="small"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      >
                        <svg-icon
                          class="greenIcon"
                          icon-class="SettingIcon"
                        ></svg-icon>
                        {{ $t("Common_Setting") }}
                      </el-button>
                      <i
                        slot="reference"
                        class="mobileSetting el-icon-setting"
                      ></i>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="tableTotalNum">
              {{
                $t("Common_TableTotalvolumns") +
                " : " +
                totalVolume +
                "&nbsp;&nbsp;&nbsp;&nbsp;" +
                $t("Common_TableTotalprofit") +
                " : " +
                totalProfit +
                " "
              }}
            </div>
            <el-pagination
              class="tablePage"
              :prev-text="$t('Common_PreviousPage')"
              :next-text="$t('Common_NexPage')"
              @current-change="handleCurrentChange"
              :page-sizes="[5, 10, 20, 50, 100]"
              @size-change="handleSizeChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, sizes"
              :pager-count="5"
              :total="total"
            >
            </el-pagination>
          </div>
          <div class="mobileTableList" v-show="mobileFlag">
            <div class="tableTotalTop">
              <span>{{ $t("Common_TableTotalvolumns") }}</span>
              <b>
                {{ totalVolume }}
              </b>
            </div>
            <div class="tableTotalTop">
              <span>{{ $t("Common_TableTotalprofit") }}</span>
              <b :class="[totalProfit > 0 ? 'greenNum' : 'redNum']">
                {{ totalProfit }}
              </b>
            </div>
            <el-collapse
              accordion
              @change="collapseChange"
              v-model="activeCollapse"
            >
              <el-collapse-item
                v-for="(item, index) in tableData"
                :key="index"
                :name="index"
              >
                <template slot="title">
                  <div class="mobileTableCard" @click.stop="showCollapse()">
                    <div class="mobileTableItem mobileTableStatusTitle">
                      <div>
                        <span v-if="item.status == 0" class="statusGreen">{{
                          $t("Common_InvitationStatus_Inviting0")
                        }}</span>
                        <span v-if="item.status == 1" class="statusYellow">{{
                          $t("Common_InvitationStatus_Agree1")
                        }}</span>
                        <span v-if="item.status == 2" class="statusRed">{{
                          $t("Common_InvitationStatus_BeRefuse2")
                        }}</span>
                        <span v-if="item.status == 3" class="statusRed">
                          {{ $t("Common_InvitationStatus_Stop3") }}
                        </span>
                        <span v-if="item.status == 4" class="statusYellow">{{
                          $t("Common_InvitationStatus_AgreeWatingActivate4")
                        }}</span>
                      </div>
                      <el-checkbox
                        class="mobileSelectCheckbox"
                        v-if="item.status == 1"
                        :value="item.checked"
                        @change="ids(item.id)"
                      ></el-checkbox>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSource") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.portfolioName }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_CustomerEmail") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.loginName }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_Mt4Account") }}
                      </p>
                       <!-- class="mobileTableContent mobileUnderline" -->
                      <p
                        class="mobileTableContent "
                        v-if="item.status == 1 || item.status == 4"
                      >
                        {{ item.mtType }}.{{ item.account }}
                      </p>
                      <p class="mobileTableContent" v-else>
                      -
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_Balance") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.balance ? item.balance : 0 }}
                      </p>
                    </div>
                  </div>
                  <div class="mobileTableBtns" @click.stop="showCollapse()">
                    <el-button
                      class="mobileBlueBtn"
                      v-if="item.status == 4"
                      @click="activateFollow(item)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="ActivateIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_Activation") }}
                    </el-button>
                    <el-button
                      class="mobileBlueBtn"
                      v-if="item.status !== 1 && item.status !== 4"
                      @click="retractFollow(item)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="RetractIcon"
                      ></svg-icon>
                      {{ $t("Common_Operate_DeleteInvite") }}
                    </el-button>
                    <el-button
                      class="mobileBlueBtn"
                      v-if="item.status == 0 || item.status == 2"
                      @click="editFollow(item)"
                      type="text"
                      size="small"
                      v-loading.fullscreen.lock="fullscreenLoading"
                    >
                      <svg-icon
                        class="greenIcon"
                        icon-class="SettingIcon"
                      ></svg-icon>
                      {{ $t("Common_Setting") }}
                    </el-button>
                  </div>
                </template>
                <div class="mobileTableCard">
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_Equity") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.equity ? item.equity : "0" }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_CopyRatio") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.followPercent + "%" }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_MaxLot") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.maxVolume == 0
                          ? $t("Common_TR_VolumeNotLimit")
                          : item.maxVolume
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_Instruments") }}
                    </p>
                    <p class="mobileTableContent">
                      <span class="symbolsSpan" v-if="item.forexSelect">
                        {{ $t("Common_Fx") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.metalsSelect">
                        {{ $t("Common_Metal") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.energySelect">
                        {{ $t("Common_Energy") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.indicesSelect">
                        {{ $t("Common_Indices") }}
                      </span>
                      <span class="symbolsSpan" v-if="item.cryptoSelect">
                        {{ $t("Common_Crypto") }}
                      </span>
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_AutoMatchOrder") }}
                    </p>
                    <p class="mobileTableContent">
                      <el-result
                        v-if="item.autoRecon"
                        icon="success"
                      ></el-result>
                      <el-result
                        v-if="!item.autoRecon"
                        icon="error"
                      ></el-result>
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_Volumes") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.volume ? item.volume : 0 }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_TableTitle_ProfitLoss") }}
                    </p>
                    <p class="mobileTableContent">
                      {{
                        item.profit
                          ? formatNumberFractionDigits(item.profit)
                          : 0
                      }}
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_LoginStatus") }}
                    </p>
                    <p
                      class="mobileTableContent loginStatus"
                      v-if="item.loginStatus == 0"
                    >
                      <el-result icon="success"></el-result>
                      <span>{{ $t("Common_LoginStatusOnline") }}</span>
                    </p>
                    <p class="mobileTableContent loginStatus" v-else>
                      <el-result icon="error"></el-result>
                      <span>{{ $t("Common_LoginStatusOutline") }}</span>
                    </p>
                  </div>
                  <div class="mobileTableItem">
                    <p class="mobileTableTitle">
                      {{ $t("Common_StartFollowHistory") }}
                    </p>
                    <p class="mobileTableContent">
                      {{ item.status == 1 ? item.followTime : "" }}
                    </p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div class="x" v-if="up && tableData.length < total">
              <i class="el-icon-loading"></i>
              {{ $t("Common_Loading") }}
            </div>
            <div class="x" v-if="!up && tableData.length >= total">
              {{ $t("Common_NoMoreData") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      :title="followAccountDrawerTitle"
      class="drawerCommon"
      :append-to-body="true"
      @close="cancelDrawer()"
      :close-on-press-escape="false"
      :visible.sync="followAccountDrawer"
      direction="rtl"
    >
      <div class="drawerContent">
        <el-form
          :model="followForm"
          :rules="rules"
          ref="followForm"
          label-width="150px"
          class="drawerForm"
          :label-position="mobileFlag ? 'top' : 'right'"
        >
          <el-form-item
            :label="$t('Common_TableTitle_CustomerEmail')"
            prop="loginId"
          >
            <el-input v-model="followForm.loginId" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item prop="following">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_CopyRatio") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_CopyRatio'),
                      $t('ViewInvitation_CopyPercentTxt'),
                      $t('ViewInvitation_CopyPercentTxt1')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i>
                  <div>
                    <div>
                      {{ $t("ViewInvitation_CopyPercentTxt") }}
                    </div>
                    <br />
                    <div>
                      {{ $t("ViewInvitation_CopyPercentTxt1") }}
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <el-input
              v-model.number="followForm.following"
              autocomplete="off"
            ></el-input>
            <b class="formPercent">%</b>
          </el-form-item>
          <el-form-item prop="maxVolume">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_MaxLot") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_MaxLot'),
                      $t('ViewInvitation_MaxVolumnTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i>
                  <div>
                    <div>
                      {{ $t("ViewInvitation_MaxVolumnTxt") }}
                    </div>
                    <br />
                    <div>
                      {{ $t("ViewInvitation_MaxVolumnTxt1") }}
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <el-input-number
              :precision="2"
              class="creaseInput"
              controls-position="right"
              :min="0"
              v-model.number="followForm.maxVolume"
              autocomplete="off"
              :placeholder="$t('Common_TR_VolumeNotLimit')"
            ></el-input-number>
            <b class="formLots">lots</b>
          </el-form-item>
          <el-form-item
            :label="$t('Common_TableTitle_Instruments')"
            prop="symbolsCheck"
          >
            <el-checkbox v-model="followForm.forexSelect">{{
              $t("Common_Fx")
            }}</el-checkbox>
            <el-checkbox v-model="followForm.metalsSelect">{{
              $t("Common_Metal")
            }}</el-checkbox>
            <el-checkbox v-model="followForm.energySelect">{{
              $t("Common_Energy")
            }}</el-checkbox>
            <el-checkbox v-model="followForm.indicesSelect">{{
              $t("Common_Indices")
            }}</el-checkbox>
            <el-checkbox v-model="followForm.cryptoSelect">{{
              $t("Common_Crypto")
            }}</el-checkbox>
          </el-form-item>
          <el-form-item prop="autoRecon">
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_AutoMatchOrder") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_AutoMatchOrder'),
                      $t('ViewInvitation_IsAutoTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i
                  >{{ $t("ViewInvitation_IsAutoTxt") }}
                </div>
              </span>
            </span>
            <el-radio-group v-model="followForm.autoRecon">
              <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
              <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            prop="agreeActivation"
            :label="$t('Common_TableTitle_ActivationStatus')"
          >
            <span slot="label">
              <span class="label-box">
                <span>{{ $t("Common_TableTitle_ActivationStatus") }} </span>
                <a
                  href="javascript:;"
                  @click.stop="
                    labelIconClick(
                      $t('Common_TableTitle_ActivationStatus'),
                      $t('ViewInvitation_MainActiveTxt')
                    )
                  "
                >
                  <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
                </a>
                <div class="labelIconTxt">
                  <i class="el-icon-caret-top labelIconBack"></i
                  >{{ $t("ViewInvitation_MainActiveTxt") }}
                </div>
              </span>
            </span>
            <el-radio-group v-model="followForm.agreeActivation">
              <el-radio :label="true">{{ $t("Common_Yes") }}</el-radio>
              <el-radio :label="false">{{ $t("Common_No") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$t('ViewInvitation_ReasonofRejection')"
            v-if="checkRow.status == 2"
          >
            <el-input
              resize="none"
              disabled
              type="textarea"
              v-model="followForm.refuseReason"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="drawerBtns">
          <el-button
            class="confirmDialogBtn"
            v-loading.fullscreen.lock="fullscreenLoading"
            @click="followSubmit()"
            >{{
              checkRow.status == undefined
                ? $t("Common_Operate_AddInvite")
                : checkRow.status == 2
                ? $t("Common_Operate_InviteAgain")
                : $t("Common_Save")
            }}</el-button
          >
          <el-button class="cancelDialogBtn" @click="cancelDrawer()">{{
            $t("Common_CloseWindow")
          }}</el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      class="mobileSearchDrawer"
      :visible.sync="mobileSearchDrawer"
      direction="ttb"
    >
      <div class="mobileFilterReturnBtnDiv">
        <el-button
          class="mobileFilterReturnBtn"
          @click="mobileSearchDrawer = false"
        >
          {{ $t("Common_Search") }}
          <i class="el-icon-arrow-up"></i>
        </el-button>
      </div>

      <el-form
        label-position="top"
        :model="tableSearchForm"
        ref="tableSearchForm"
      >
        <el-form-item
          :label="$t('Common_TableTitle_SignalSource')"
          prop="PortfolioName"
        >
          <el-input v-model="tableSearchForm.PortfolioName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_Mt4Account')"
          prop="Account"
        >
          <el-input v-model="tableSearchForm.Account"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_CustomerEmail')"
          prop="LoginName"
        >
          <el-input v-model="tableSearchForm.LoginName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_AutoMatchOrder')"
          prop="AutoRecon"
        >
          <el-select v-model="tableSearchForm.AutoRecon">
            <el-option :label="$t('Common_Yes')" value="true"></el-option>
            <el-option :label="$t('Common_No')" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Common_TableTitle_Status')" prop="Status">
          <el-select v-model="tableSearchForm.Status">
            <el-option :label="$t('Common_AllStatus')" value=""></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_Inviting0')"
              value="0"
            ></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_AgreeWatingActivate4')"
              value="4"
            ></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_BeRefuse2')"
              value="2"
            ></el-option>
            <el-option
              :label="$t('Common_InvitationStatus_Agree1')"
              value="1"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="mobileFilterBottomBtns">
        <el-button class="resetFormBtn" @click="resetForm()">
          {{ $t("Common_Reset") }}
        </el-button>
        <el-button class="serchFormBtn" @click="getData(1, pageSize)">
          {{ $t("Common_Search") }}
        </el-button>
      </div>
    </el-drawer>
    <PopupTips
      :popupVisible="isPopupVisible"
      :icon="iconImg"
      :title="$t('Common_Prompt')"
      @confirmPopupTips="confirmPopup"
      @cancelPopupTips="cancelPopup"
      :isHtml="true"
      ref="popupTipsRef"
      :subContent="$t(subContent)"
      :content="$t(popupContent)"
      :btnType="2"
    />

    <div class="mobileLabelTips" ref="mobileLabelTips" v-if="isLableTips">
      <svg-icon class="labelIcon" icon-class="LabelIcon"></svg-icon>
      <p>
        {{ labelTitle }}
      </p>
      <div>
        <div>
          {{ labelTxt }}
        </div>
        <br />
        <div v-if="labelSubContent">
          {{ labelSubContent }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { concatParams, concatTableData } from "../../plugins/common.js";
import { mapState } from "vuex";
import PopupTips from "@/components/moudule/PopupTips.vue";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import { formatNumberFractionDigits } from "@/shared/utils/formatNumber.js";

BScroll.use(Pullup);

export default {
  name: "FollowHistory",
  components: {
    PopupTips,
  },
  computed: {
    ...mapState(["checkPortfolio", "userInfo", "token", "mobileFlag"]),
  },
  data() {
    var checkSymbol = (rule, value, callback) => {
      if (
        !this.followForm.forexSelect &&
        !this.followForm.energySelect &&
        !this.followForm.indicesSelect &&
        !this.followForm.metalsSelect &&
        !this.followForm.cryptoSelect
      ) {
        callback(new Error(this.$t("Common_valid_CheckSymbolNot")));
      } else {
        callback();
      }
    };
    var checkPercent = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(this.$t("Common_Valid_CheckCopyPercentNotNull"))
        );
      } else {
        var reg = /^([1-9]\d|[1-9]\d{2,4}|100000)$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t("Common_Valid_CheckCopyPercentNotF")));
        } else {
          callback();
        }
      }
    };
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
      tableSearchForm: {
        PortfolioName: "",
        Account: "",
        AutoRecon: "",
        Activation: "",
        FollowStatus: "",
        LoginName: "",
      },
      followAccountDrawer: false,
      fullscreenLoading: false,
      followForm: {
        loginId: "",
        following: 100,
        maxDrawdown: 0,
        maxVolume: undefined,
        symbols: [],
        autoRecon: true,
        agreeActivation: true,
        energySelect: true,
        forexSelect: true,
        indicesSelect: true,
        metalsSelect: true,
        cryptoSelect: true,
        symbolsCheck: [],
      },
      rules: {
        loginId: [
          {
            required: true,
            message: this.$t("Common_valid_CheckCustomAccountNotNull"),
            trigger: "blur",
          },
        ],
        symbolsCheck: [{ validator: checkSymbol, trigger: "change" }],
        following: [{ validator: checkPercent, trigger: "blur" }],
      },
      checkRow: {},
      reason: "",
      followAccountDrawerTitle: "",
      labelTitle: "",
      labelTxt: "",
      isLableTips: false,
      idList: [],
      isPopupVisible: false,
      iconImg: require("../../assets/images/NotifyWarning.svg"),
      popupContent: "",
      clickType: "",
      totalProfit: 0,
      totalVolume: 0,
      subContent: "",
      labelSubContent: "",
      mobileSearchDrawer: false,
      selectionList: [],
      up: false,
      firstOpen: false,
      activeCollapse: 0,
    };
  },

  created() {
    if (this.$route.query.status) {
      this.tableSearchForm.Status = this.$route.query.status;
      this.getData(1, this.pageSize);
    } else {
      this.getData(1, this.pageSize);
    }
  },
  methods: {
    formatNumberFractionDigits,
    openSearch() {
      this.mobileSearchDrawer = true;
    },
    showCollapse() {},
    collapseChange() {
      this.$nextTick(() => {
        if (!this.firstOpen) {
          if (this.tableData.length !== 1) {
            this.scroll.maxScrollY = this.scroll.maxScrollY - 320;
          }
          this.firstOpen = true;
        } else {
          if (this.tableData.length !== 1) {
            this.scroll.maxScrollY = this.scroll.maxScrollY + 320;
          }
          this.firstOpen = false;
        }
        console.log(this.scroll.maxScrollY);
      });
    },
    scrollFn() {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3,
          });
        } else {
          this.scroll.refresh();
        }

        //touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
        this.scroll.on("touchEnd", (pos) => {
          //上拉加载 总高度>下拉的高度+10 触发加载更多
          if (this.scroll.maxScrollY > pos.y + 50) {
            // console.log("加载更多")
            this.up = true;
            setTimeout(() => {
              //使用refresh 方法 来更新scroll  解决无法滚动的问题
              if (this.tableData.length < this.total) {
                this.currentPage = this.currentPage + 1;
                this.getData(this.currentPage, this.pageSize, "noRefresh");
                this.scroll.refresh();
                this.up = false;
              } else {
                this.up = false;
              }
            }, 1000);
          }
        });
      });
    },
    getData(pageIndex, pageSize, tag) {
        const loading = this.$loading({
        lock: true,
      });
      if (!this.mobileFlag || tag !== "noRefresh") {
        this.tableData = [];
      }
      var params = {
        PortfolioName: this.tableSearchForm.PortfolioName.trim(),
        Account: this.tableSearchForm.Account.trim(),
        LoginName: this.tableSearchForm.LoginName.trim(),
        AutoRecon: this.tableSearchForm.AutoRecon,
        Status: this.tableSearchForm.Status
          ? Number(this.tableSearchForm.Status)
          : "",
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      this.$axios
        .post("/Api/subAccount/Index", params)
        .then((res) => {
          let dt = res.data;

          if (dt.isSuccess) {
            this.totalProfit = dt.result.totalProfit;
            this.totalVolume = dt.result.totalVolume;
            this.total = dt.result.total;
            if (this.mobileFlag && tag == "noRefresh") {
              dt.result.pageList.forEach((item) => {
                this.tableData.push(item);
              });
            } else {
              this.tableData = concatTableData(
                dt.result.pageList,
                dt.result.total,
                this.currentPage,
                this.pageSize
              );
            }

            this.fullscreenLoading = false;
            if (this.mobileFlag) {
              this.scrollFn();
            }
          }
        })
        .finally(() => {
          this.mobileSearchDrawer = false;
            loading.close();
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, this.pageSize);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, this.pageSize);
    },
    resetForm() {
      this.$refs.tableSearchForm.resetFields();
      this.currentPage = 1;
       this.getData(this.currentPage, this.pageSize);
    },
    cancelDrawer() {
      this.$refs.followForm.resetFields();
      this.followAccountDrawer = false;
    },
    followSubmit() {
      this.$refs.followForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          var params = {
            portfolioId: this.checkPortfolio.id,
            loginId: this.followForm.loginId.trim(),
            following: this.followForm.following,
            maxVolume:
              this.followForm.maxVolume == undefined
                ? 0
                : this.followForm.maxVolume,
            autoRecon: this.followForm.autoRecon,
            agreeActivation: this.followForm.agreeActivation,
            energySelect: this.followForm.energySelect,
            forexSelect: this.followForm.forexSelect,
            indicesSelect: this.followForm.indicesSelect,
            metalsSelect: this.followForm.metalsSelect,
            cryptoSelect: this.followForm.cryptoSelect,
            id: this.checkRow.id,
          };
          this.$axios
            .post("/Api/SubAccount/AddInvite", params)
            .then((res) => {
              let dt = res.data;
              if (dt.isSuccess) {
                this.$notify.success({
                  title: this.$t("Common_Prompt"),
                  message: this.$t("Common_OperateSuccess"),
                });

                this.getData(this.currentPage, this.pageSize);
                this.$refs.followForm.resetFields();
                this.followAccountDrawer = false;
              } else {
                this.$notify.error({
                  title: this.$t("Common_Prompt"),
                  message: dt.result,
                });
              }
            })
            .finally(() => {
              this.fullscreenLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 设置
    editFollow(row) {
      const loading = this.$loading({
        lock: true,
      });
      this.followAccountDrawerTitle = this.$t("Common_Setting");
      this.checkRow = row;
      this.$axios.get("/Api/SubAccount/InviteSet?id=" + row.id).then((res) => {
        let dt = res.data;
        if (dt.isSuccess) {
          this.followAccountDrawer = true;
          this.$nextTick(function () {
            this.followForm = Object.assign(this.followForm, dt.result);
            this.followForm.maxVolume =
              this.followForm.maxVolume == 0
                ? undefined
                : this.followForm.maxVolume;
          });
        } else {
          this.$notify.error({
            title: this.$t("Common_Prompt"),
            message: dt.result,
          });
        }
      }).finally(()=>{
        loading.close();
      });
    },
    cancelPopup(val) {
      this.isPopupVisible = val;
      this.subContent = "";
    },
    confirmPopup(val) {
      this.isPopupVisible = val;
      this.subContent = "";
      if (this.clickType == "delete") {
        this.deleteInvite();
      }
    },
    // 激活
    activateFollow(row) {
      this.fullscreenLoading = true;
      var params = {
        id: row.id,
      };
      this.$axios
        .get("/Api/SubAccount/ActiveFollow" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    // 删除邀请
    retractFollow(row) {
      this.clickType = "delete";
      this.popupContent = "SignalSource_StopDeleteConfirm";
      this.checkRow = row;
      this.isPopupVisible = true;
    },
    deleteInvite() {
      const loading = this.$loading({
        lock: true,
      });
      var params = {
        id: this.checkRow.id,
      };
      this.$axios
        .get("/Api/SubAccount/RecallInvite" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.$notify.success({
              title: this.$t("Common_Prompt"),
              message: this.$t("Common_OperateSuccess"),
            });

            const totalPage = Math.ceil((this.total - 1) / this.pageSize); // 总页数
            this.currentPage =
              this.currentPage > totalPage ? totalPage : this.currentPage;
            this.currentPage = this.currentPage < 1 ? 1 : this.currentPage;

            this.getData(this.currentPage, this.pageSize);
          } else {
            this.$notify.error({
              title: this.$t("Common_Prompt"),
              message: dt.result,
            });
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    labelIconClick(title, content, subContent) {
      if (this.mobileFlag) {
        this.isLableTips = !this.isLableTips;
        this.labelTitle = title;
        this.labelTxt = content;
        this.labelSubContent = subContent;
      } else {
        this.isLableTips = false;
      }
    },
    screenClick() {
      // debugger
      document.addEventListener("click", (e) => {
        if (this.$refs.mobileLabelTips) {
          let self = this.$refs.mobileLabelTips.contains(e.target);
          if (!self) {
            this.isLableTips = false;
            this.labelSubContent = "";
          }
        }
      });
    },
    

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("Common_Total");
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          column.property === "profit" ||
          column.property === "volume" ||
          column.property === "equity" ||
          column.property === "balance"
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          sums[index] = formatNumberFractionDigits(sums[index]);
        } else {
          sums[index] = " ";
        }
      });

      return sums;
    },
    //获取数组中数值的下标
    indexOf(val, ids) {
      for (let i = 0; i < ids.length; i++) {
        //获取当前值的下标
        if (ids[i] === val) {
          return i;
        }
      }
      return -1;
    },

    //多选赋值ids
    ids(val) {
      //检索下标,判断当前值(或对象是否在数组中); 在则返回在的对象,不在则返回-1
      let index = this.indexOf(val, this.selectionList);
      if (this.selectionList.length > 0 && index > -1) {
        //删除数组中的某个元素(在取消勾选时,删除数组中的值)
        this.selectionList.splice(index, 1);
      } else {
        //id添加到数组中
        this.selectionList.push(val);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageTitle {
  justify-content: flex-start;
  align-items: center;
}
.operateBtns {
  padding-left: 0;
}
.refreshListBtnDiv {
  margin-left: 10px;
  .confirmDialogBtn {
    color: #fff;
    text-align: center;
    font-family: "PingFangSC-Medium";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    padding: 8px 10px;
  }
}

.serchFormBtn {
  margin-right: 30px;
  margin-bottom: 30px;
}

@media screen and (max-width: 767px) {
  .mobileFilterDiv {
    justify-content: space-between;
  }
}
</style>
